module.exports = __webpack_public_path__ + "images/psp/content/car-psp-rich-content-2.png";